const fmt = (iso) => new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/London", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const EnquiriesList = ({ enquiries }) => {
  if (enquiries.length === 0) {
    return <p className="border-t border-white/10 py-10 text-sm text-slate-500" data-testid="admin-enquiries-empty">No enquiries yet.</p>;
  }
  return (
    <ul data-testid="admin-enquiries-list">
      {enquiries.map((e) => (
        <li key={e.id} className="grid gap-3 border-t border-white/10 py-5 md:grid-cols-12" data-testid={`admin-enquiry-${e.id}`}>
          <div className="md:col-span-3">
            <p className="font-mono text-xs tracking-[0.1em] text-white">{fmt(e.created_at)}</p>
            <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-gold">{e.interest}</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-sm text-white">{e.name}</p>
            <a href={`mailto:${e.email}`} className="text-xs text-slate-400 hover:text-gold">{e.email}</a>
            <p className="text-xs text-slate-500">{e.company || "—"}</p>
          </div>
          <p className="text-sm leading-relaxed text-slate-300 md:col-span-6">{e.message}</p>
        </li>
      ))}
    </ul>
  );
};
